import { toast } from "sonner";
import api from "@/lib/api";

export async function startCheckout(lookupKey, userId) {
  try {
    const { data } = await api.post("/payments/checkout", {
      lookup_key: lookupKey,
      origin_url: window.location.origin,
      user_id: userId || null,
    });
    if (data.checkout_url) {
      window.location.href = data.checkout_url;
    }
  } catch (e) {
    toast.error("Could not start checkout. Please try again.");
  }
}
